import React from "react";
import { toJS } from "mobx";
import { WeaTablePage, WeaLocaleProvider } from "ecCom";
const formatMultiLang = WeaLocaleProvider.formatMultiLang;

import { observer } from "mobx-react";
import isFunction from "lodash/isFunction";
import remove from "lodash/remove";
import middleware from "../../../middleware";

@observer
class WeaTableMobx extends React.Component {
  componentDidMount() {
    const { comsWeaTableStore } = this.props;
    if (this.props.uniqueId) {
      comsWeaTableStore.tableUpdate({
        uniqueId: this.props.uniqueId,
        rowKey: this.props.rowKey
      });
    }
    if (this.props.rowKey && typeof this.props.rowKey === "function") {
      comsWeaTableStore.tableUpdate({
        rowKey: this.props.rowKey
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { comsWeaTableStore } = nextProps;
    if (nextProps.uniqueId != comsWeaTableStore.uniqueId) {
      comsWeaTableStore.tableUpdate({
        uniqueId: nextProps.uniqueId,
        rowKey: nextProps.rowKey
      });
    }
  }
  getRowSel() {
    const { comsWeaTableStore, rowSelection } = this.props;
    const {
      selectedRowKeys,
      selectedUniqueIds,
      uniqueId,
      rootMap
    } = comsWeaTableStore;
    let rowSel = {
      ...rowSelection,
      type: (rootMap && rootMap.tabletype) || "checkbox",
      selectedRowKeys: uniqueId
        ? toJS(selectedUniqueIds)
        : toJS(selectedRowKeys),
      onChange(sRowKeys, selectedRows) {
        comsWeaTableStore.setSelectedRowKeys(sRowKeys);
        rowSelection &&
          isFunction(rowSelection.onChange) &&
          rowSelection.onChange(
            comsWeaTableStore.selectedRowKeys,
            selectedRows
          );
      }
    };

    return rowSel;
  }

  getColumns(params) {
    const { comsWeaTableStore, getColumns } = this.props;
    const { columns } = comsWeaTableStore;
    let newColumns = toJS(columns);
    newColumns = newColumns.map(column => {
      let newColumn = { ...column };
      //let align=column.align==undefined?"left":column.align;
      let dataalign = column.dataalign == undefined ? "" : column.dataalign;
      //style={{display:"block",textAlign:align}}
      //newColumn.title=<span>{newColumn.title}</span>;
      //AndyZhang对齐功能
      // 处理autoZoom
      if (newColumn.autoZoom) {
        newColumn.className =
          (newColumn.className || "") + " wea-table-auto-zoom-col";
      }
      newColumn.render = (text, record) => {
        // 前端元素转义
        const valueSpan =
          record[`${newColumn.dataIndex}span`] !== undefined
            ? record[`${newColumn.dataIndex}span`]
            : record[newColumn.dataIndex];
        let value = formatMultiLang(valueSpan);
        return (
          <span
            className="wea-url"
            style={{ textAlign: dataalign }}
            dangerouslySetInnerHTML={{ __html: value }}
          />
        );
      };
      // handle resize
      if (params && params.size) {
        newColumn.width = "100px";
      }
      return newColumn;
    });
    if (typeof getColumns === "function") {
      newColumns = getColumns(newColumns) || newColumns; //避免测试时不写返回值直接报错
    }
    return newColumns;
  }

  onRowClick = (record, index, event) => {
    const {
      comsWeaTableStore,
      onRowClick,
      needRowCheck,
      needRowClick
    } = this.props;
    const {
      uniqueId,
      selectedRowKeys,
      rowKey,
      setSelectedRowKeys,
      setRowCheckKey
    } = comsWeaTableStore;
    const _selectedRowKeys = toJS(selectedRowKeys);
    const id = rowKey ? rowKey(record, index) : record.randomFieldId;
    _selectedRowKeys.indexOf(id) <= -1
      ? _selectedRowKeys.push(id)
      : remove(_selectedRowKeys, n => n === id);
    //是否开启行选中
    if (needRowCheck) {
      setSelectedRowKeys(_selectedRowKeys);
    }
    if (needRowClick) {
      setRowCheckKey([id]);
    }
    isFunction(onRowClick) && onRowClick(record, index, event);
  };

  render() {
    const {
      comsWeaTableStore,
      hasOrder,
      needScroll,
      needRowClick,
      onOperatesClick = "",
      getRender,
      needPagesSelectdKeys,
      setColCB
    } = this.props;
    const {
      // table
      dataKey,
      datas,
      browser,
      operates,
      sortParams,
      loading,
      showCheck,
      pageAutoWrap,
      rowstylefield,
      // 自定义列
      colSetVisible,
      colSetdatas,
      colSetKeys,
      // pagination
      count,
      current,
      pageSize,
      rootMap,
      isSts,
      stsAllData,
      stsData,
      stsDatas,
      rowCheckKey
    } = comsWeaTableStore;
    if (getRender && typeof getRender === "function") {
      return getRender(comsWeaTableStore, this.props);
    }
    return (
      <WeaTablePage
        useFixedHeader={true}
        {...this.props}
        needRowClick={needRowClick}
        rowCheckKey={toJS(rowCheckKey)}
        dataKey={dataKey}
        browser={browser}
        hasOrder={hasOrder}
        needScroll={needScroll}
        loading={loading}
        tableCheck={showCheck}
        pageAutoWrap={pageAutoWrap}
        rowstylefield={rowstylefield}
        isSts={isSts}
        stsAllData={stsAllData}
        stsData={stsData}
        stsDatas={stsDatas}
        count={count}
        current={current}
        pageSize={pageSize}
        rootMap={rootMap}
        datas={toJS(datas)}
        columns={this.getColumns()}
        rowSel={this.getRowSel()}
        operates={toJS(operates)}
        sortParams={toJS(sortParams)}
        onChange={(p, f, s) =>
          comsWeaTableStore.getDatas(
            "",
            p.current,
            p.pageSize,
            s,
            () => {},
            false
          )
        }
        colSetVisible={colSetVisible}
        colSetdatas={toJS(colSetdatas)}
        colSetKeys={toJS(colSetKeys)}
        showColumnsSet={bool => comsWeaTableStore.setColSetVisible(bool)}
        onTransferChange={keys => comsWeaTableStore.setTableColSetkeys(keys)}
        saveColumnsSet={() =>
          comsWeaTableStore.tableColSet(undefined, setColCB)
        }
        saveColumnsReset={() =>
          comsWeaTableStore.tableColSet(undefined, setColCB, true)
        }
        onOperatesClick={onOperatesClick}
        onRowClick={this.onRowClick}
      />
    );
  }
}

const Com = middleware(WeaTableMobx, "WeaTableNew");
export default Com;



// WEBPACK FOOTER //
// ./comMobx/wea-table-new/components/Table.js